class InputValidator {
  checkNumeric(event) {
    event = event ? event : window.event;
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    } else {
      return true;
    }
  }

  isNumber(value: string | null, min: number | null = null): boolean {
    if (!value) {
      return false;
    }

    if (this.isEmptyOrSpaces(value)) {
      return false;
    }

    const parsedNumber = Number(value);

    if (isNaN(parsedNumber) || parsedNumber == undefined) {
      return false;
    }

    if (min && parsedNumber < min) {
      return false;
    }

    return true;
  }

  isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }
}

const inputValidator = new InputValidator();

export { inputValidator };
